<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      class="elevation-0"
      hide-default-footer
      :loading="loading"
      :items-per-page="perPage"
    >
      <template v-slot:item.active="{ item }">
        <span v-if="item.active" class="green--text font-weight-bold">
          {{ $t('conglomerates.active') }}
        </span>
        <span v-else class="orange--text darken-2 font-weight-bold">
          {{ $t('conglomerates.inactive') }}
        </span>
      </template>

      <template v-slot:item.country="{ item }">
        <span>{{ item.country && item.country.name || '-' }}</span>
      </template>

      <template v-slot:item.edit="{ item }">
        <router-link :to="`/edit/conglomerates/${item.id}`" class="mx-1">
          <v-icon>mdi-pencil-outline</v-icon>
        </router-link>
      </template>
    </v-data-table>

    <div class="text-center pt-2">
      <v-pagination
        @input="setValue($event)"
        :length="length"
        :value="value"
        circle
        :disabled="length < 1"
        :total-visible="7"
      />
    </div>
  </v-container>
</template>

<script>
const headerBuilder = (text, value, sortable = true) => ({
  text,
  value,
  sortable,
  align: 'center',
});

export default {
  name: 'ConglomeratesDataTable',
  props: {
    loading: { type: Boolean, default: true },
    items: { type: Array, default: () => [] },
    value: { type: [String, Number], default: 1 },
    length: { type: [String, Number], default: 1 },
  },
  data: () => ({
    perPage: 15,
  }),
  computed: {
    headers() {
      return [
        headerBuilder('ID', 'id'),
        headerBuilder(this.$t('conglomerates.conglomerate_name'), 'name'),
        headerBuilder(this.$t('conglomerates.country'), 'country', false),
        headerBuilder(this.$t('conglomerates.status'), 'active'),
        headerBuilder(this.$t('conglomerates.total_schools'), 'totalSchools'),
        headerBuilder(this.$t('conglomerates.total_licenses'), 'totalLicenses'),
        headerBuilder(this.$t('general.edit'), 'edit', false),
      ];
    },
  },
  methods: {
    setValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>
